import React, { useCallback } from 'react'
import useInterests from '../../../hooks/use-interests'
import { uniq } from 'lodash'
import { Row, Col, Form } from 'react-bootstrap'

const InterestsCheckboxSelector = ({
    value = [],
    onChange = () => {}
}) => {
    const { interests, isBusy } = useInterests()

    const onCheckChange = useCallback((id, checked) => {
        if (checked) {
            onChange(uniq([...value, id]))
        } else {
            onChange(value.filter( v => v !== id))
        }
    }, [onChange, value])

    const renderInterest = (interest, key) => {
        const checked = value.includes(interest.id)
        return (
            <Col xs={12} sm={6} key={key}>
                <Form.Check inline type='checkbox' label={interest.name} checked={!!checked} onChange={e => onCheckChange(interest.id, Boolean(e.target.checked))} />
            </Col>
        )
    }

    return (
        <Row>
            {interests.map(renderInterest)}
        </Row>
    )
}

export default InterestsCheckboxSelector